import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import { tap } from 'rxjs/operators';
import { Report, RequestStatus, NGXLogger } from '@app/shared';
import { ReportService } from '@app/core';
import {
  ReportActionTypes,
  GetJobReports,
  GetJobReportsSuccess,
  GetJobReportsFailure,

  GenerateJobReport,
  GenerateJobReportSuccess,
  GenerateJobReportFailure,

  GetPageReports,
  GetPageReportsSuccess,
  GetPageReportsFailure,

  GeneratePageReport,
  GeneratePageReportSuccess,
  GeneratePageReportFailure

} from '../actions/report.actions';


@Injectable()
export class ReportEffects {

  constructor(
    private actions: Actions,
    private reportService: ReportService,
    private router: Router,
    private logger:NGXLogger,
  ) { }


    @Effect()
    GetJobReports: Observable<any> = this.actions
        .ofType(ReportActionTypes.GET_JOB_REPORTS)
        .debounceTime(10)
        .map((action: GetJobReports) => action.payload)
        .switchMap(payload => {
          return this.reportService.getJobReports(payload.job.uuid)
            .map((result) => {

              // // init report members
              // result.data.map(report => {
              //   report.members = [];
              //   report.tags = report.tags?report.tags.split(','):null;
              //   if(report.colour && report.colour.charAt(0) != "#")
              //     report.colour = `#${report.colour}`;
              // });

              return new GetJobReportsSuccess({reports:result.data})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetJobReportsFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetJobReportsSuccess: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GET_JOB_REPORTS_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetJobReportsFailure: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GET_JOB_REPORTS_FAILURE)
    );


    @Effect()
    GenerateJobReport: Observable<any> = this.actions
        .ofType(ReportActionTypes.GENERATE_JOB_REPORT)
        .debounceTime(10)
        .map((action: GenerateJobReport) => action.payload)
        .switchMap(payload => {
          return this.reportService.generateJobReport(payload.job.uuid,payload.type,payload.addInfo)
            .map((result) => {
              let jobs = [];

              //this.logger.debug(jobs)
              // result.data.map(job => {
              //   let tmpJob = Object.assign(new Job(), job);
              //   var docSegs = [];
              //   job.documentSegments.map(ds => {
              //     let tmpDS = Object.assign(new DocumentSegment(), ds);
              //     docSegs.push(tmpDS);
              //   })
              //   tmpJob.documentSegments = docSegs;
              //   jobs.push(tmpJob)
              // });
              return new GenerateJobReportSuccess({jobs:jobs})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to generate the report."

              return Observable.of(new GenerateJobReportFailure({ errorStatus: rs }));
            });
        })

    @Effect({ dispatch: false })
    GenerateJobReportSuccess: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GENERATE_JOB_REPORT_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GenerateJobReportFailure: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GENERATE_JOB_REPORT_FAILURE)
    );


    // PAGE REPORTS
    @Effect()
    GetPageReports: Observable<any> = this.actions
        .ofType(ReportActionTypes.GET_PAGE_REPORTS)
        .debounceTime(10)
        .map((action: GetPageReports) => action.payload)
        .switchMap(payload => {
          return this.reportService.getPageReports(payload.documentSegment.uuid)
            .map((result) => {

              // // init report members
              // result.data.map(report => {
              //   report.members = [];
              //   report.tags = report.tags?report.tags.split(','):null;
              //   if(report.colour && report.colour.charAt(0) != "#")
              //     report.colour = `#${report.colour}`;
              // });

              return new GetPageReportsSuccess({reports:result.data})
            })
            .catch((error) => {
              this.logger.debug(error);
              return Observable.of(new GetPageReportsFailure({ error: error }));
            });
        })



    @Effect({ dispatch: false })
    GetPageReportsSuccess: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GET_PAGE_REPORTS_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GetPageReportsFailure: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GET_PAGE_REPORTS_FAILURE)
    );


    @Effect()
    GeneratePageReport: Observable<any> = this.actions
        .ofType(ReportActionTypes.GENERATE_PAGE_REPORT)
        .debounceTime(10)
        .map((action: GeneratePageReport) => action.payload)
        .switchMap(payload => {
          return this.reportService.generatePageReport(payload.documentSegment.uuid,payload.type,payload.addInfo)
            .map((result) => {
              let documentSegments = [];

              //this.logger.debug(documentSegments)
              // result.data.map(documentSegment => {
              //   let tmpPage = Object.assign(new Page(), documentSegment);
              //   var docSegs = [];
              //   documentSegment.documentSegments.map(ds => {
              //     let tmpDS = Object.assign(new DocumentSegment(), ds);
              //     docSegs.push(tmpDS);
              //   })
              //   tmpPage.documentSegments = docSegs;
              //   documentSegments.push(tmpPage)
              // });
              return new GeneratePageReportSuccess({documentSegments:documentSegments})
            })
            .catch((error) => {
              this.logger.debug(error);
              let rs : RequestStatus = new RequestStatus();
              rs.code = error.status;
              rs.msg = error.statusText;
              rs.msg = "Sorry unable to generate the report."

              return Observable.of(new GeneratePageReportFailure({ errorStatus: rs }));
            });
        })

    @Effect({ dispatch: false })
    GeneratePageReportSuccess: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GENERATE_PAGE_REPORT_SUCCESS),
      tap((result) => {
        this.logger.debug(result, ' in tap')
      })
    );

    @Effect({ dispatch: false })
    GeneratePageReportFailure: Observable<any> = this.actions.pipe(
      ofType(ReportActionTypes.GENERATE_PAGE_REPORT_FAILURE)
    );


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/store/effects/report.effects.ts